import { OrganizationModel } from "models/company/entities/OrganizationModel";
import type { IUserBaseModel } from "./UserBaseModel";


export interface IUserModel extends IUserBaseModel {
  fullName?: string;
  countryCode: string;
  organizations: OrganizationModel[];
  phone: string;
  isLocker?: boolean;
}

export abstract class UserModel {
  uuid?: string;
  email: string;
  firstName: string;
  lastName: string;
  fullName?: string;
  countryCode: string;
  phone: string;
  organizations: OrganizationModel[];

  constructor(data: IUserModel) {
    this.uuid = data.uuid;
    this.email = data.email;
    this.firstName = data.firstName;
    this.lastName = data.lastName;
    this.fullName = data.fullName;
    this.countryCode = data.countryCode;
    this.phone = data.phone;
    this.organizations = data.organizations.map(i => new OrganizationModel(i)) ?? [];
  }
}